<template>
  <el-dialog
    title="删除费用"
    :visible.sync="visible"
    width="400px"
    :before-close="handleClose"
  >
    <div class="delete-tips">
      <i class="el-icon-warning"></i>
      <span
        >确定要删除【{{
          form.feeDetail || "该条费用记录"
        }}】吗？删除后不可恢复！</span
      >
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="danger" @click="handleSubmit" :loading="loading"
        >确 定 删除</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { deleteFundPayment } from "@/api/fee/fundPaymentApi";

export default {
  name: "DeleteFee",
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        fundPaymentId: "", // 修复：改为资金支付表主键字段
        feeDetail: "",
        communityId: "",
      },
    };
  },
  methods: {
    open(fee) {
      this.visible = true;
      // 修复：从入参中获取正确的主键字段（fundPaymentId）
      this.form = {
        fundPaymentId: fee.fundPaymentId,
        feeDetail: fee.feeDetail,
        communityId: this.$parent.getCommunityId(),
      };
    },
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        fundPaymentId: "", // 重置时同步修改
        feeDetail: "",
        communityId: "",
      };
    },
    async handleSubmit() {
      try {
        this.loading = true;
        // 修复：传递正确的参数名（fundPaymentId）给后端接口
        await deleteFundPayment({
          fundPaymentId: this.form.fundPaymentId,
          communityId: this.form.communityId,
          statusCd: "1", // 补充：软删除标识（根据后端逻辑，0=有效，1=删除）
        });
        this.$message.success("删除成功");
        this.handleClose();
        this.$emit("handleRefreshFee");
      } catch (error) {
        console.error("删除失败:", error);
        this.$message.error("删除失败");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.delete-tips {
  padding: 20px 0;
  color: #f56c6c;
  font-size: 14px;
  text-align: center;
}

.delete-tips i {
  font-size: 24px;
  margin-right: 10px;
  vertical-align: middle;
}

.dialog-footer {
  text-align: center;
}
</style>
